import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { default as searchActions } from 'src/store/modules/search/actions';
import SearchModelProductClass from 'src/model/searchModelProduct.model';
import SearchBar from './SearchBar';
import { withI18n } from 'react-i18next';

import { analyticsActions } from 'src/analytics/store';

interface IStateFromProps {
  searchText: string;
  results: SearchModelProductClass;
  isLoggedIn: boolean;
  searchLoading: boolean;
}

interface IDispatchFromProps {
  handleDoSearch(searchText: string): void;
  handleSetText: (searchText: string) => void;
  fireProductClickEvent: (data: any) => void;
  fireProductImpressionEvent: (data: any) => void;
}

const mapStateToProps = (state: any) => ({
  searchText: state.search.text,
  results: state.search.results,
  isLoggedIn: state.signin.success,
  searchLoading: state.search.loading
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  handleDoSearch: (searchText: string, page?: number, onFinish?: any) =>
    dispatch(searchActions.search(searchText, page, onFinish)),
  handleSetText: (searchText: string) =>
    dispatch(searchActions.searchText(searchText)),
  fireProductClickEvent: (data: any) =>
    dispatch(analyticsActions.searchResultProductClick(data)),
  fireProductImpressionEvent: (data: any) =>
    dispatch(analyticsActions.searchResultImpressions(data))
});

export default connect<IStateFromProps, IDispatchFromProps, void>(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(SearchBar)));
